import { Drawer } from 'antd';
import { Button } from 'components/Button';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';
import { useSelector } from 'react-redux';
import { activeStatusOptions,uniformGenderOptions } from 'utils/constants';

const ResignationFilterDrawer = ({
   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [placement] = useState('right');  
   const {
    department
} = useSelector((state) => state.common);


const [departmentOption, setDepartmentOption] = useState([]);



useEffect(()=>{
    let _department = department?.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })

    setDepartmentOption(_department)  

},[department])




   const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}
      >
        <div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>

    

        <div className='col-12 mb-3' >
          {/* Deptment Filter */}
          <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'} options={departmentOption} value={setFilterValue("department")} placeholder={"Select Department"}/>
        </div>

        <div className='col-12 mb-3' >
         {/* Gender Filter */}
         <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "gender")}} optionLabel={"label"} optionValue={'value'} options={uniformGenderOptions} value={setFilterValue("gender")} placeholder={"Select Gender"}/>
        </div>

       

        <div className='col-12 mb-3' >
             {/* Status Filter */}
         <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "status")}} optionLabel={"label"} optionValue={'value'} options={activeStatusOptions} value={setFilterValue("status")} placeholder={"Select Status"}/>
        </div>

    

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>    
     
       </div>

      </Drawer>
    </>
  );
};
export default ResignationFilterDrawer;